module.exports = __webpack_public_path__ + "static/media/Serenity soffa 4sits Sense 4001 beige miljö 2024 2.a77da78e.jpg";